export default class AsyncRequestQueue {
    constructor() {
        this.queue = [];
        this.isProcessing = false;
    }
    enqueue(request) {
        this.queue.push(request);
        if (!this.isProcessing) {
            this.processQueue();
        }
    }
    clear() {
        this.queue = [];
    }
    processQueue() {
        if (this.queue.length === 0) {
            this.isProcessing = false;
            return;
        }
        this.isProcessing = true;
        const request = this.queue.shift();
        if (request) {
            request()
                .then(() => {
                this.processQueue();
            })
                .catch(() => {
                this.processQueue();
            });
        }
    }
}
//# sourceMappingURL=AsyncRequestQueue.js.map